import axiosInstance from '../axiosInterceptor/axiosInstance'

// Returns { tosVersionId, versionTag, effectiveDate, body }
const getTos = () => axiosInstance.get('v1/consent/tos').then((r) => r.data)

export default getTos
